/* eslint-disable camelcase */
/* eslint-disable camelcase */
<template>
  <div>
    <div class="sleepOcclusion">
      <div class="sleepOcclusion__option">
        <div class="occlusionOption">
          <div class="occlusionOption__box">
            <h6>Reason</h6>
            <div class="multiline">
            <b-form-textarea
              id="textarea"
              v-model="reason"
              placeholder="reason..."
              rows="1"
              max-rows="3"
            ></b-form-textarea>
        </div>
          </div>

          <div class="occlusionOption__box">
            <h6> Cover </h6>
            <div class="occlusionOption__box--font">
              <input type="checkbox"
                     style="cursor:pointer;"
                     id="eyeCover" name="eyeCover"
                     v-model="eyeCover"/>
              <label for="eyeCover" style="cursor:pointer;"> &nbsp; Eye Cover </label>
            </div>
            <div class="occlusionOption__box--font">
              <input type="checkbox"
                     style="cursor:pointer;"
                     id="noseCover"
                     name="noseCover"
                     v-model="noseCover"/>
              <label for="noseCover" style="cursor:pointer;"> &nbsp; Nose Cover </label>
            </div>
            <div class="occlusionOption__box--font">
              <input type="checkbox"
                     style="cursor:pointer;"
                     id="mouthCover"
                     name="mouthCover"
                     v-model="mouthCover"/>
              <label for="mouthCover" style="cursor:pointer;"> &nbsp; Mouth Cover </label>
            </div>
          </div>
          <div class="occlusionOption__box">
            <h6> Extra State </h6>
            <div class="occlusionOption__box--font">
              <input type="checkbox"
                     style="cursor:pointer;"
                      id="noseOccl"
                      name="noseOccl"
                      v-model="noseOccl"/>
              <label for="noseOccl" style="cursor:pointer;"> &nbsp; Nose Occl </label>
            </div>
            <div class="occlusionOption__box--font">
              <input type="checkbox"
                     style="cursor:pointer;"
                     id="eyeOpen"
                     name="eyeOpen"
                     v-model="eyeOpen"/>
              <label for="eyeOpen" style="cursor:pointer;"> &nbsp; Eye Open </label>
            </div>
            <div class="occlusionOption__box--font">
              <input type="checkbox"
                     style="cursor:pointer;"
                     id="hasHand"
                     name="hasHand"
                     v-model="hasHand"/>
              <label for="hasHand" style="cursor:pointer;"> &nbsp; Has Hand </label>
            </div>
            <div class="occlusionOption__box--font">
              <input type="checkbox"
                     style="cursor:pointer;"
                     id="hasPacifier"
                     name="hasPacifier"
                     v-model="hasPacifier"/>
              <label for="hasPacifier" style="cursor:pointer;"> &nbsp; Has Pacifier </label>
            </div>
          </div>
          <div class="occlusionOption__box">
            <h6>Landmark</h6>
            <div v-if="PropsSwitchPen==='dot'" class="occlusionOption__box--font">
              <input type="radio"
                     style="cursor:pointer;"
                     name="landmark"
                     id="eye"
                     value="eye"
                     v-model="PropsLandmark"/>
              <label for="eye" style="cursor:pointer;" > &nbsp; eye </label>
            </div>
            <div v-if="PropsSwitchPen==='dot'" class="occlusionOption__box--font">
              <input type="radio"
                     style="cursor:pointer;"
                     name="landmark"
                     id="nose"
                     value="nose"
                     v-model="PropsLandmark"/>
              <label for="nose" style="cursor:pointer;"> &nbsp; nose </label>
            </div>
            <div v-if="PropsSwitchPen==='dot'" class="occlusionOption__box--font">
              <input type="radio"
                     style="cursor:pointer;"
                     name="landmark"
                     id="mouth"
                     value="mouth"
                     v-model="PropsLandmark"/>
              <label for="mouth" style="cursor:pointer;"> &nbsp; mouth </label>
            </div>
            <div v-else-if="PropsSwitchPen==='rect'" class="occlusionOption__box--font">
              <input type="radio"
                     style="cursor:pointer;"
                     name="landmark"
                     id="head"
                     value="head"
                     v-model="PropsLandmark"/>
              <label for="head" style="cursor:pointer;"> &nbsp; head </label>
            </div>

          </div>
          <div class="occlusionOption__box">
            <div v-for="item in feedbackStoreRectData"
                 :key="item.index"
                 :style="{color:classDecideColor[item.class]}">
              <button @click="deleteStoredRectData(item)">x</button>
              {{item.class}} [{{item.bbox[0]}},{{item.bbox[1]}}] -> [{{item.bbox[2]}},{{item.bbox[3]}}]
            </div>
          </div>
          <div class="occlusionOption__box">
            <h6> Marked</h6>
            <div :key="item.index" v-for="item in feedbackStoreDotData">
                {{item.part}} [X:{{item.x}}, Y:{{item.y}}]
            </div>
          </div>
          <button class="btn btn-secondary btn-fashion"
                  @click="deleteStoreData()"
                  style="margin:10px; width:230px;"> Delete </button>
          <div>
            <button class="btn btn-info"
                    style="margin:10px; width:150px;"
                    @click.prevent="hideBox()">{{PropsHideBox}} box (Esc)</button>
            </div>
        </div>
      </div>

      <div class="sleepOcclusion__right">
        <div class="sleepOcclusion__right--image">
          <labeledImage
            :PropsBatchType="PropsBatchType"
            :PropsHideBox="PropsHideBox"
            :PropsBatchDate="PropsBatchDate"
            :PropsImgName="PropsImgName"
            :PropsBoxTimes="PropsBoxTimes"
            :PropsLevelThree="PropsLevelThree"
            :PropsLandmark="PropsLandmark"
            :PropsDelete="PropsDelete"
            :PropsRectDataFromApi="PropsRectDataFromApi"
            :PropsDotsDataFromApi="PropsDotsDataFromApi"
            :PropsSwitchPen="PropsSwitchPen"
            :PropsSpaceKeydown="PropsSpaceKeydown"
            @feedbackStoreDotData="getbackFromChild"
            @feedbackStoreRectData="getRectBackFromChild"
            @feedbackSpaceKeyDown="getBackSpaceKeyDown"
          >
          </labeledImage>
        </div>
        <div class="sleepOcclusion__right--control">
          <button class="btn btn-info"
                  style="margin-right:20px; width:60px;"
                  @click.prevent="switchPen()">{{PropsSwitchPen}}</button>
          <div v-if="is_uncertain">
              <button class="btn btn-primary mg-r-ten btn-fashion" @click.prevent="uncertain()">
              cancel Uncertain</button>
            </div>
            <div v-else>
              <button class="btn btn-secondary mg-r-ten btn-fashion" @click.prevent="uncertain()">
                Uncertain</button>
            </div>
          <div v-if="is_skip">
            <button class="btn btn-primary mg-r-ten btn-fashion" @click.prevent="skip()">
              cancelSkip</button>
          </div>
          <div v-else>
            <button class="btn btn-secondary mg-r-ten btn-fashion" @click.prevent="skip()">
              Skip</button>
          </div>
          <button
            class="btn btn-secondary mg-r-ten btn-fashion"
            @click.prevent="backward()"
            :disabled="current===1"
          >
            <i class="fas fa-backward"></i>
          </button>
          <button
            class="btn btn-secondary mg-r-ten btn-fashion"
            :disabled="total===current"
            @click.prevent="forward()"
          >
            <i class="fas fa-forward"></i>
          </button>
          <button class="btn btn-primary btn-fashion" @click.prevent="storeAndNext()">
              Correct &amp; Next</button>
          <div style="margin:5px; text-align:right; font-size:18px;">{{current}} / {{total}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/api/client';
import labeledImage from '@/components/labeledImage/labeledImage.vue';

export default {
  components: { labeledImage },
  data() {
    return {
      PropsBatchType: 'sleep_occl',
      PropsBatchDate: null,
      PropsImgName: null,
      PropsBoxTimes: null,
      PropsRectDataFromApi: null,
      PropsLevelThree: true,
      PropsLandmark: 'eye',
      PropsDelete: false,
      PropsHideBox: 'Hide',
      PropsDotsDataFromApi: [],
      PropsSwitchPen: 'dot',
      PropsSpaceKeydown: false,
      feedbackStoreDotData: [],
      feedbackStoreRectData: [],
      current: 0,
      total: 0,
      imageNameList: [], // 儲存已產生過的img
      eyeCover: null,
      noseCover: null,
      mouthCover: null,
      noseOccl: null,
      eyeOpen: null,
      hasHand: null,
      hasPacifier: null,
      is_skip: null,
      is_uncertain: false,
      reason: '',
      classDecideColor: {
        person: '#24ceb9',
        face: 'darkorchid',
        head: 'red',
        hand: 'cornflowerblue',
        leg: 'khaki',
        bed: 'green',
        ear: '#EE7700',
      },
    };
  },
  methods: {
    loadRejectedList() {
      const vm = this;
      const params = {
        batch_date: vm.batch_date,
      };
      client.get(`metas/${vm.PropsBatchType}/rejected?`, params).then((res) => {
        res.metas.forEach((item) => {
          vm.imageNameList.push(item.name);
        });
        vm.total = vm.imageNameList.length;
        vm.nextLabel();
      });
    },
    getMeta() {
      const vm = this;
      client.get(`/meta/sleep_occl/${vm.imageNameList[vm.current - 1]}`).then((res) => {
        console.log('get');
        console.log(res);
        vm.is_skip = res.is_skip;
        if (res.is_uncertain) {
          vm.is_uncertain = res.is_uncertain;
        } else {
          vm.is_uncertain = false;
        }
        vm.PropsBatchDate = res.batch_date;
        vm.PropsImgName = res.name;
        vm.PropsBoxTimes = res.bbox_head;
        vm.PropsRectDataFromApi = vm.initHeadPropsRectDataFromApi(res.bbox_head);
        vm.PropsDotsDataFromApi = [];
        vm.PropsLandmark = 'eye';
        vm.initOption();
        vm.showCheckboxAndRadioFromApi(res);
        vm.createPropsDotsDataFromApi(res.landmarks);
        vm.reason = res.reason;
      });
    },
    nextLabel() {
      const vm = this;
      if (vm.current < vm.total) {
        vm.current += 1;
        vm.getMeta();
      } else {
        client.get('/meta/sleep_occl/to_label').then((res) => {
          console.log('get');
          console.log(res);
          vm.is_skip = res.is_skip;
          if (res.is_uncertain) {
            vm.is_uncertain = res.is_uncertain;
          } else {
            vm.is_uncertain = false;
          }
          vm.PropsBatchDate = res.batch_date;
          vm.PropsImgName = res.name;
          vm.PropsBoxTimes = res.bbox_head;
          vm.PropsRectDataFromApi = vm.initHeadPropsRectDataFromApi(res.bbox_head);
          // console.log(vm.PropsRectDataFromApi);
          vm.PropsLandmark = 'eye';
          vm.PropsDotsDataFromApi = [];
          vm.imageNameList.push(vm.PropsImgName);
          vm.current += 1;
          vm.total += 1;
          vm.initOption();
          vm.showCheckboxAndRadioFromApi(res);
          vm.createPropsDotsDataFromApi(res.landmarks);
        });
      }
    },
    skip() {
      const vm = this;
      vm.updateLabel(vm.PropsImgName, !vm.is_skip, false);
    },
    uncertain() {
      const vm = this;
      vm.updateLabel(vm.PropsImgName, false, !vm.is_uncertain);
    },
    backward() {
      const vm = this;
      vm.current -= 1;
      vm.PropsDotsDataFromApi = [];
      vm.getMeta();
    },
    forward() {
      const vm = this;
      vm.current += 1;
      vm.PropsDotsDataFromApi = [];
      vm.getMeta();
    },
    storeAndNext() {
      const vm = this;
      vm.updateLabel(vm.PropsImgName, false, false);
    },
    updateLabel(name, is_skip, is_uncertain) {
      const vm = this;
      const occl_data = vm.createDataForBackend();
      const body = {
        landmarks: occl_data.landmarks,
        occl_state: occl_data.occl_state,
        cover_state: occl_data.cover_state,
        eye_open: occl_data.eye_open,
        has_hand: occl_data.has_hand,
        has_pacifier: occl_data.has_pacifier,
        name,
        is_skip,
        is_uncertain,
      };
      console.log(vm.feedbackStoreRectData);
      if (vm.feedbackStoreRectData.length > 0) {
        body.bbox_head = vm.feedbackStoreRectData[0].bbox;
      }
      client.post('meta/sleep_occl/correct_reject', null, body).then((res) => {
        vm.initOption();
        vm.nextLabel();
      });
    },
    getbackFromChild(data) {
      this.feedbackStoreDotData = data;
    },
    getRectBackFromChild(data) {
      this.feedbackStoreRectData = data;
      // console.log('rect');
      // console.log(this.feedbackStoreRectData);
    },
    getBackSpaceKeyDown(data) {
      this.PropsSpaceKeydown = data;
    },
    deleteStoreData() {
      this.PropsDelete = true;
      setTimeout(() => { this.PropsDelete = false; }, 1000);
    },
    createLandmarksData() {
      const vm = this;
      const landmarksData = [];
      const eyeArray = vm.feedbackStoreDotData.filter((item) => item.part === 'eye');
      const noseArray = vm.feedbackStoreDotData.filter((item) => item.part === 'nose');
      const mouthArray = vm.feedbackStoreDotData.filter((item) => item.part === 'mouth');
      landmarksData[0] = (eyeArray.length >= 1) ? eyeArray[0].x : -1;
      landmarksData[1] = (eyeArray.length >= 1) ? eyeArray[0].y : -1;
      landmarksData[2] = (eyeArray.length === 2) ? eyeArray[1].x : -1;
      landmarksData[3] = (eyeArray.length === 2) ? eyeArray[1].y : -1;
      landmarksData[4] = (noseArray.length === 1) ? noseArray[0].x : -1;
      landmarksData[5] = (noseArray.length === 1) ? noseArray[0].y : -1;
      landmarksData[6] = (mouthArray.length >= 1) ? mouthArray[0].x : -1;
      landmarksData[7] = (mouthArray.length >= 1) ? mouthArray[0].y : -1;
      landmarksData[8] = (mouthArray.length === 2) ? mouthArray[1].x : -1;
      landmarksData[9] = (mouthArray.length === 2) ? mouthArray[1].y : -1;
      return landmarksData;
    },
    createOcclData() {
      const vm = this;
      const occlData = [0, 0, 0, 0];
      const eyeArray = vm.feedbackStoreDotData.filter((item) => item.part === 'eye');
      // const noseArray = vm.feedbackStoreDotData.filter((item) => item.part === 'nose');
      const mouthArray = vm.feedbackStoreDotData.filter((item) => item.part === 'mouth');
      if (eyeArray.length === 0) {
        occlData[0] = 1;
        occlData[1] = 1;
      } else if (eyeArray.length === 1) {
        occlData[0] = 1;
      }
      if (vm.noseOccl === true) {
        occlData[2] = 1;
      }
      if (mouthArray.length === 0) {
        occlData[3] = 1;
      }
      return occlData;
    },
    createCoverState() {
      const vm = this;
      const coverState = [];
      coverState[0] = (vm.eyeCover) ? 1 : 0;
      coverState[1] = (vm.noseCover) ? 1 : 0;
      coverState[2] = (vm.mouthCover) ? 1 : 0;
      return coverState;
    },
    createDataForBackend() {
      const vm = this;
      const landmarksData = vm.createLandmarksData();
      const occlData = vm.createOcclData();
      const coverState = vm.createCoverState();
      const dataForBackend = {
        landmarks: landmarksData,
        occl_state: occlData,
        cover_state: coverState,
        eye_open: (vm.eyeOpen) ? 1 : 0,
        has_hand: (vm.hasHand) ? 1 : 0,
        has_pacifier: (vm.hasPacifier) ? 1 : 0,
        is_skip: false,
      };
      return dataForBackend;
    },
    initOption() {
      const vm = this;
      vm.eyeCover = null;
      vm.noseCover = null;
      vm.mouthCover = null;
      vm.noseOccl = null;
      vm.eyeOpen = null;
      vm.hasHand = null;
      vm.hasPacifier = null;
      vm.PropsSwitchPen = 'dot';
    },
    showCheckboxAndRadioFromApi(data) {
      const vm = this;
      if (data.cover_state[0] === 1) {
        vm.eyeCover = true;
      } else {
        vm.eyeCover = false;
      }
      if (data.cover_state[1] === 1) {
        vm.noseCover = true;
      } else {
        vm.noseCover = false;
      }
      if (data.cover_state[2] === 1) {
        vm.mouthCover = true;
      } else {
        vm.mouthCover = false;
      }
      if (data.occl_state[2] === 1) {
        vm.noseOccl = true;
      } else {
        vm.noseOccl = false;
      }
      if (data.eye_open === 1) {
        vm.eyeOpen = true;
      } else {
        vm.eyeOpen = false;
      }
      if (data.has_hand === 1) {
        vm.hasHand = true;
      } else {
        vm.hasHand = false;
      }
      if (data.has_pacifier === 1) {
        vm.hasPacifier = true;
      } else {
        vm.hasPacifier = false;
      }
    },
    createPropsDotsDataFromApi(data) {
      const vm = this;
      vm.PropsDotsDataFromApi = [];
      if (data[0] !== -1 && data[1] !== -1) {
        vm.PropsDotsDataFromApi.push({
          x: data[0],
          y: data[1],
          part: 'eye',
        });
      }
      if (data[2] !== -1 && data[3] !== -1) {
        vm.PropsDotsDataFromApi.push({
          x: data[2],
          y: data[3],
          part: 'eye',
        });
      }
      if (data[4] !== -1 && data[5] !== -1) {
        vm.PropsDotsDataFromApi.push({
          x: data[4],
          y: data[5],
          part: 'nose',
        });
      }
      if (data[6] !== -1 && data[7] !== -1) {
        vm.PropsDotsDataFromApi.push({
          x: data[6],
          y: data[7],
          part: 'mouth',
        });
      }
      if (data[8] !== -1 && data[9] !== -1) {
        vm.PropsDotsDataFromApi.push({
          x: data[8],
          y: data[9],
          part: 'mouth',
        });
      }
    },
    hideBox() {
      const vm = this;
      if (vm.PropsHideBox === 'Hide') {
        vm.PropsHideBox = 'Show';
      } else {
        vm.PropsHideBox = 'Hide';
      }
    },
    initHeadPropsRectDataFromApi(res) {
      const data = [{
        bbox: [],
        class: 'head',
      }];
      for (let i = 0; i < res.length; i += 1) {
        data[0].bbox[i] = res[i];
      }
      return data;
    },
    deleteStoredRectData(item) {
      const vm = this;
      if (item === 'all') {
        vm.feedbackStoreRectData.splice(0, vm.feedbackStoreRectData.length);
        vm.PropsRectDataFromApi = vm.feedbackStoreRectData;
      } else {
        vm.feedbackStoreRectData.splice(vm.feedbackStoreRectData.indexOf(item), 1);
        vm.PropsRectDataFromApi = vm.feedbackStoreRectData;
      }
    },
    switchPen() {
      const vm = this;
      if (vm.PropsSwitchPen === 'dot') {
        vm.PropsSwitchPen = 'rect';
        vm.PropsLandmark = 'head';
        vm.deleteStoredRectData('all');
      } else {
        vm.PropsSwitchPen = 'dot';
        vm.PropsLandmark = 'eye';
      }
    },
  },
  mounted() {
    const vm = this;
    vm.loadRejectedList();
    // eslint-disable-next-line
    document.onkeydown = function (e) {
      const keycode = {
        ArrowUp: () => {
          vm.skip();
        },
        Enter: () => {
          vm.storeAndNext();
          e.preventDefault();
        },
        ArrowLeft: () => {
          if (vm.current !== 1) {
            vm.backward();
          }
        },
        ArrowRight: () => {
          if (vm.total !== vm.current) {
            vm.forward();
          }
        },
        KeyE: () => {
          if (vm.PropsLandmark === 'eye') {
            vm.PropsLandmark = 'mouth';
          } else if (vm.PropsLandmark === 'nose') {
            vm.PropsLandmark = 'eye';
          } else if (vm.PropsLandmark === 'mouth') {
            vm.PropsLandmark = 'nose';
          }
        },
        KeyD: () => {
          if (vm.PropsLandmark === 'eye') {
            vm.PropsLandmark = 'nose';
          } else if (vm.PropsLandmark === 'nose') {
            vm.PropsLandmark = 'mouth';
          } else if (vm.PropsLandmark === 'mouth') {
            vm.PropsLandmark = 'eye';
          }
        },
        Escape: () => {
          vm.hideBox();
        },
        KeyC: () => {
          if (!vm.PropsSpaceKeydown && vm.PropsSwitchPen === 'rect') {
            console.log('spcae key down');
            vm.PropsSpaceKeydown = true;
          }
        },
      };
      keycode[e.code]();
    };
  },
  watch: {
    noseCover() {
      if (this.noseCover === true) {
        this.noseOccl = true;
      }
    },
    noseOccl() {
      if (this.noseCover === true) {
        setTimeout(() => { this.noseOccl = true; }, 100);
      }
    },
  },
};
</script>
